export class OrgaoProfissiografico {
	codigoOrgao?: number;
	nomeOrgao?: string;
}
